const system = {
    IMPERIAL: 'IMPERIAL',
    METRIC: 'METRIC',
    SI: 'SI',
    HYBRID: 'HYBRID',
    EUROPEAN: 'EUROPEAN',
    CUSTOM: 'CUSTOM'
};

export default system;